import { Button } from 'components/atoms';
import { Form, Formik, FormikHelpers } from 'formik';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';

import { FormInput } from 'components/molecules';
import { PublicPage } from 'components/templates';
import { useMutateOptions } from 'hooks';
import i18next from 'i18next';
import { useTranslation } from 'react-i18next';
import { PiUser } from 'react-icons/pi';
import { useSearchParams } from 'react-router-dom';
import { useLogin } from 'services/auth';
import * as Yup from 'yup';

type LoginFormModel = {
  email: string;
  password: string;
};

const validationSchema = Yup.object().shape({
  email: Yup.string()
    .email(i18next.t('formik-error.invalid-email'))
    .required(i18next.t('formik-error.required')),
  password: Yup.string()
    .min(3, i18next.t('formik-error.invalid-password'))
    .required(i18next.t('formik-error.required')),
});

const Login = () => {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const login = useLogin();
  const mutateOptions = useMutateOptions<LoginFormModel>();

  const onLogin = async (
    values: LoginFormModel,
    helpers: FormikHelpers<LoginFormModel>
  ) => {
    await login.mutateAsync(values, mutateOptions(helpers));
  };

  return (
    <Formik
      validateOnBlur
      validationSchema={validationSchema}
      initialValues={{
        email: params.get('email') ?? '',
        password: '',
      }}
      onSubmit={onLogin}>
      {({ values }) => (
        <PublicPage
          header={
            <>
              <PiUser />
              {t('login.header')}
            </>
          }
          footer={<></>}>
          <Form>
            <FormInput.Text
              name='email'
              type='email'
              label={t('input.label.email')}
            />
            <FormInput.Text
              name='password'
              type='password'
              label={t('input.label.password')}
            />
            <Button
              type='submit'
              isLoading={login.isPending}
              variant={BUTTON_VARIANT.submit}
              fullWidth>
              <Button.Text text={t('login.button')} />
            </Button>
          </Form>
        </PublicPage>
      )}
    </Formik>
  );
};
export default Login;
